//@flow
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import getter from 'dibs-object-getter';

import { FolderMenuOption } from './FolderMenuOption';

import styles from './FolderMenu.scss';

import type { FolderMenu_viewer as Viewer } from './__generated__/FolderMenu_viewer.graphql';

type Props = {
    closeModal?: Function,
    firmId: ?string,
    onFolderSelection: Function,
    viewer: Viewer,
};

export function FolderMenuComponent(props: Props) {
    const { closeModal, firmId, onFolderSelection, viewer } = props;

    const portfoliosEdges = getter(viewer).at('portfolios').value('edges') || [];

    const portfolios = portfoliosEdges.map(edge => getter(edge).value('node')).filter(p => !!p);

    if (!portfolios.length) {
        return (
            <div className={styles.container}>
                <div className={styles.errorHeader}>
                    <FormattedMessage
                        id="abf.designProfile.favorites.connectModal.empty"
                        defaultMessage="No Portfolios Available"
                    />
                </div>
                <div className={styles.errorMessage}>
                    <FormattedMessage
                        id="abf.designProfile.favorites.connectModal.emptyDescription"
                        defaultMessage="There are no public favorites folders for this trade firm.  Please create a public folder and try again."
                    />
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            {portfolios.map(portfolio => {
                if (!portfolio) {
                    return null;
                }

                return (
                    <FolderMenuOption
                        closeModal={closeModal}
                        key={portfolio.serviceId}
                        portfolio={(portfolio: Object)}
                        onFolderSelection={onFolderSelection}
                        firmId={firmId}
                    />
                );
            })}
        </div>
    );
}

export const FolderMenu = createFragmentContainer(FolderMenuComponent, {
    viewer: graphql`
        fragment FolderMenu_viewer on Viewer {
            portfolios(
                first: 100
                portfolioTypes: [FOLDER]
                sortBy: MODIFIED
                userIds: $firmMembers
            ) {
                edges {
                    node {
                        serviceId
                        ...FolderMenuOption_portfolio
                    }
                }
            }
        }
    `,
});
